interface Adaptation {
  chat_id: string;
}

export function livechatTemplatesManageAdapter(
  attendanceId: string,
): Adaptation {
  return {
    chat_id: attendanceId,
  }
}
